import React, { useEffect, useState } from 'react';
import { Navigation, Pagination, EffectCoverflow } from 'swiper/modules';
import CarouselSlideContent from './CarouselSlide';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';
import "../../styles/style_carousel.css";

const Carrousel = ( { data } ) => {

  const isSlideVisible = (slide) => {
    const now = new Date();
    const dateProgrammation = new Date(slide.datepimg);
    return slide.isvisible && dateProgrammation <= now;
  };

  return (
    <section id="tranding">
      <div className="container">
        <h1 className="text-center section-heading slide-left">Nos Créations</h1>
      </div>

      <div id="carrousel" className="container">
        <Swiper
          modules={[Navigation, Pagination, EffectCoverflow]}
          effect="coverflow"
          grabCursor={true}
          centeredSlides={true}
          loop={true}
          slidesPerView="auto"
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 2.5
          }}
          pagination={{
            el: '.swiper-pagination',
            clickable: true
          }}
          navigation={{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }}
          className="tranding-slider"
        >
          {data.filter(isSlideVisible).map(slide => (
            <SwiperSlide key={slide.id} className="tranding-slide"><CarouselSlideContent slide={slide} /></SwiperSlide>
          ))}

          <div className="tranding-slider-control">
            <div className="swiper-button-prev slider-arrow"><ion-icon name="arrow-back-outline"></ion-icon></div>
            <div className="swiper-pagination"></div>
            <div className="swiper-button-next slider-arrow"><ion-icon name="arrow-forward-outline"></ion-icon></div>
          </div>
        </Swiper>
      </div>
    </section>
  );
};

export default Carrousel;
